import { IconButton, Menu, MenuItem, useTheme } from "@mui/material";
import { useState } from "react";
import { trackBrand } from "~src/api/brands";
import Iconify from "~src/components/Iconify";
import { Brand } from "~src/types/brand";

export const MobileMenu = ({ brand }: { brand: Brand }) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <IconButton
        id="brand-mobile-menu-button"
        aria-controls={open ? "brand-mobile-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{
          backgroundColor: "white",
          border: `1px solid ${theme.palette.grey[300]}`,
        }}
      >
        <Iconify icon="ri:more-fill" />
      </IconButton>
      <Menu
        id="brand-mobile-menu"
        aria-labelledby="brand-mobile-menu-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <TrackMenuItem brand={brand} />
        {brand.brandsite && (
          <MenuItem
            onClick={() => {
              window.open(brand.brandsite, "_blank");
              handleClose();
            }}
          >
            <Iconify
              icon="tabler:external-link"
              sx={{
                mr: 1,
              }}
            />
            Website
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

const TrackMenuItem = ({ brand }: { brand: Brand }) => {
  const [tracked, setTracked] = useState(brand.tracked || false);

  const handleClick = () => {
    setTracked(!tracked);
    trackBrand(brand.brand_id, !tracked);
  };

  return (
    <MenuItem onClick={handleClick}>
      <Iconify
        icon={tracked ? "ph:heart-fill" : "ph:heart"}
        color={tracked ? "red" : undefined}
        sx={{
          mr: 1,
        }}
      />
      {tracked ? "Tracked" : " Track"}
    </MenuItem>
  );
};
